/**
 * Save State Manager
 *
 * Manages game state persistence for resume functionality.
 * Saves player position, timer, and height when exiting to menu.
 */

export interface SaveState {
  bloboX: number;
  bloboY: number;
  bloboStartY: number; // Original ground level Y position for height tracking
  timerElapsed: number;
  currentHeight: number;
  maxHeight: number;
  timestamp: number;
}

export class SaveStateManager {
  private static readonly STORAGE_KEY = 'blobo_save_state';

  /**
   * Save current game state
   */
  public static saveState(state: SaveState): void {
    try {
      state.timestamp = Date.now();
      localStorage.setItem(SaveStateManager.STORAGE_KEY, JSON.stringify(state));
      console.log('💾 Game state saved:', state);
    } catch (error) {
      console.error('Failed to save game state:', error);
    }
  }

  /**
   * Load saved game state
   */
  public static loadState(): SaveState | null {
    try {
      const stored = localStorage.getItem(SaveStateManager.STORAGE_KEY);
      if (stored) {
        const state = JSON.parse(stored) as SaveState;
        console.log('📂 Game state loaded:', state);
        return state;
      }
    } catch (error) {
      console.error('Failed to load game state:', error);
    }
    return null;
  }

  /**
   * Clear saved game state
   */
  public static clearState(): void {
    try {
      localStorage.removeItem(SaveStateManager.STORAGE_KEY);
      console.log('🗑️ Game state cleared');
    } catch (error) {
      console.error('Failed to clear game state:', error);
    }
  }

  /**
   * Check if there is a saved state
   */
  public static hasSavedState(): boolean {
    return localStorage.getItem(SaveStateManager.STORAGE_KEY) !== null;
  }
}
